import { atom } from 'jotai'

// #region READONLY

// Boolean atom indicating if the equivalent products drawer is open
export const isEquivalentProductsDrawerOpenAtom = atom<boolean>(false)

// Atom storing the product slug for which to display equivalent products
export const equivalentProductsSlugAtom = atom<string | undefined>(undefined)

// #endregion

// #region SETTERS

// Atom action to open the equivalent products drawer with a specific product slug
export const openEquivalentProductsDrawerAtom = atom(null, (_, set, slug: string) => {
  set(equivalentProductsSlugAtom, slug)
  set(isEquivalentProductsDrawerOpenAtom, true)
})

// Atom action to close the equivalent products drawer and reset the slug
export const closeEquivalentProductsDrawerAtom = atom(null, (_, set) => {
  set(isEquivalentProductsDrawerOpenAtom, false)
})

// #endregion
